module.exports = __webpack_public_path__ + "static/media/picnic_area_icon.1c34afd6.svg";